/* ============================================================================
   VITALIA LISTICLE  ·  window.__vitaliaListicle namespace
   Re-scoped from branded-listicle scaffold. Buy-form logic removed — this build
   is CTA-mode only. Counters, FAQ accordion, testimonials carousel, sticky bar.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__vitaliaListicle) return;
  window.__vitaliaListicle = { initialized: false };

  var SCOPE = '.shopify-section.section-vitalia-listicle';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  // ─── Animated counters ─────────────────────────────────────────────
  function animateCounter(el) {
    if (el.dataset.counterDone === '1') return;
    el.dataset.counterDone = '1';
    var raw = el.getAttribute('data-counter-target') || '0';
    var target = parseFloat(raw);
    var prefix = el.getAttribute('data-counter-prefix') || '';
    var suffix = el.getAttribute('data-counter-suffix') || '';
    if (!isFinite(target) || target === 0) {
      el.textContent = prefix + raw + suffix;
      return;
    }
    var hasDecimal = String(target).indexOf('.') !== -1;
    var decimals = hasDecimal ? (String(target).split('.')[1] || '').length : 0;
    var duration = 1400;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      var value = target * eased;
      var formatted = hasDecimal ? value.toFixed(decimals) : Math.round(value).toLocaleString();
      el.textContent = prefix + formatted + suffix;
      if (p < 1) window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function initCounters(section) {
    var counters = $$('[data-counter]', section);
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCounter);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCounter(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  }

  // ─── FAQ accordion ─────────────────────────────────────────────────
  function initFaq(section) {
    var items = $$('[data-faq-item]', section);
    items.forEach(function (item) {
      var btn = item.querySelector('.vl__faq-btn');
      var panel = item.querySelector('[data-faq-panel]');
      if (!btn || !panel) return;
      if (item.getAttribute('data-open') === 'true') {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      on(btn, 'click', function () {
        var open = item.getAttribute('data-open') === 'true';
        if (open) {
          item.setAttribute('data-open', 'false');
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '0px';
        } else {
          item.setAttribute('data-open', 'true');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
    on(window, 'resize', function () {
      $$('[data-faq-item][data-open="true"]', section).forEach(function (item) {
        var p = item.querySelector('[data-faq-panel]');
        if (p) p.style.maxHeight = p.scrollHeight + 'px';
      });
    });
  }
  // Now uses native <details>/<summary> — no JS needed.
  // Browser handles open/close, accessibility, keyboard nav natively.

  // ─── Testimonials carousel ─────────────────────────────────────────
  function initTestimonials(section) {
    var car = section.querySelector('[data-testimonials]');
    if (!car) return;
    var track = car.querySelector('[data-testimonials-track]');
    var dotsWrap = car.querySelector('[data-testimonials-dots]');
    if (!track) return;
    var slides = $$('.vl__testimonial', track);
    if (slides.length === 0) return;

    var idx = 0;
    var total = slides.length;
    var autoplay = car.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(car.getAttribute('data-autoplay-ms') || '6000', 10);
    var timer = null;

    function render() {
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      if (dotsWrap) {
        $$('.vl__testimonials-dot', dotsWrap).forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }
    }
    function go(d) {
      idx = (idx + d + total) % total;
      render();
      restartAutoplay();
    }
    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      timer = setInterval(function () {
        idx = (idx + 1) % total;
        render();
      }, autoplayMs);
    }
    function restartAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
      startAutoplay();
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'vl__testimonials-dot' + (i === idx ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        (function (k) {
          on(d, 'click', function () { idx = k; render(); restartAutoplay(); });
        })(i);
        dotsWrap.appendChild(d);
      }
    }

    on(car.querySelector('[data-testimonials-dir="prev"]'), 'click', function () { go(-1); });
    on(car.querySelector('[data-testimonials-dir="next"]'), 'click', function () { go(1); });

    on(car, 'mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
    on(car, 'mouseleave', startAutoplay);

    render();
    startAutoplay();
  }

  // ─── Sticky CTA bar ────────────────────────────────────────────────
  function initStickyBar(section) {
    var bar = section.querySelector('[data-sticky]');
    if (!bar) return;
    var showAfter = parseInt(bar.getAttribute('data-show-after') || '600', 10);
    var hideNearEnd = parseInt(bar.getAttribute('data-hide-near-end') || '92', 10);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var y = h.scrollTop || window.pageYOffset;
      var pct = max > 0 ? (y / max * 100) : 0;
      var shouldShow = y > showAfter && pct < hideNearEnd;
      bar.classList.toggle('is-visible', shouldShow);
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    on(window, 'resize', update);
    update();
  }

  // ─── Init all sections ─────────────────────────────────────────────
  function init() {
    if (window.__vitaliaListicle.initialized) return;
    window.__vitaliaListicle.initialized = true;
    $$(SCOPE).forEach(function (section) {
      initCounters(section);
      initFaq(section);
      initTestimonials(section);
      initStickyBar(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-vitalia-listicle')) {
      window.__vitaliaListicle.initialized = false;
      init();
    }
  });
})();